import type { AdType } from '../types';
import type { Option } from '../../../components/common/CheckboxAutocomplete';

export type SortingOption = [string, string];

export const SORTING_OPTIONS: SortingOption[] = [
  [['total_reach_delta', 'desc'].join(':'), 'Total reach delta (Desc)'],
  [['total_reach_delta', 'asc'].join(':'), 'Total reach delta (Asc)'],
];

export const SORTING_OPTIONS_US: SortingOption[] = [
  [['winner_confidence_score', 'desc'].join(':'), 'Winner confidence score (Desc)'],
  [['winner_confidence_score', 'asc'].join(':'), 'Winner confidence score (Asc)'],
  [['longevity', 'desc'].join(':'), 'Longevity (Desc)'],
  [['longevity', 'asc'].join(':'), 'Longevity (Asc)'],
  [['ads_count', 'desc'].join(':'), 'Number of ads with this creative (Desc)'],
  [['ads_count', 'asc'].join(':'), 'Number of ads with this creative (Asc)'],
];

export const SORTING_OPTIONS_GOOGLE_US: SortingOption[] = [
  [['winner_confidence_score', 'desc'].join(':'), 'Winner confidence score (Desc)'],
  [['winner_confidence_score', 'asc'].join(':'), 'Winner confidence score (Asc)'],
  [['longevity', 'desc'].join(':'), 'Longevity (Desc)'],
  [['longevity', 'asc'].join(':'), 'Longevity (Asc)'],
  [['variations_count', 'desc'].join(':'), 'Number of variations for this creative (Desc)'],
  [['variations_count', 'asc'].join(':'), 'Number of variations for this creative (Asc)'],
];

export const LANGUAGE_OPTIONS: Option[] = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
  { label: 'French', value: 'fr' },
  { label: 'German', value: 'de' },
  { label: 'Italian', value: 'it' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Polish', value: 'pl' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Czech', value: 'cs' },
  { label: 'Dutch', value: 'nl' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Greek', value: 'el' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Croatian', value: 'hr' },
  { label: 'Korean', value: 'ko' },
];

const types: AdType[] = ['image', 'video'];
export const AD_TYPES_OPTIONS = types.map((type) => ({ value: type, label: type }));
